import styled from 'styled-components';

const DistrictField = styled.div`
  -webkit-flex: 1;
flex: 1;
`;

export default DistrictField;
